(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beat-the-heat-hero-assets"] && !Shopify.designMode) return;
  try {
    class BeatTheHeatHero {
  constructor(section) {
    this.section = section;
    this.productImages = section.querySelectorAll('.beat-the-heat-hero__product-image');

    this.enableLoadAnimation = this.section.dataset.enableLoadAnimation === 'true';
    this.enableParallax = this.section.dataset.enableParallax === 'true';

    this.hatConfig = {
      'top-left': {
        from: 'translate(-68%, -100%)',
        to: 'translate(-68%, -160%)',
        className: 'beat-the-heat-hero__product-image--top-left'
      },
      'center': {
        from: 'translate(-30%, -50%)',
        to: 'translate(-30%, -100%)',
        className: 'beat-the-heat-hero__product-image--center'
      },
      'bottom-right': {
        from: 'translate(0, 0)',
        to: 'translate(0, -30%)',
        className: 'beat-the-heat-hero__product-image--bottom-right'
      }
    };

    this.scrollTriggers = [];
    this.isInitialized = false;

    this.waitForGSAP()
      .then((loaded) => {
        if (loaded) {
          this.init();
        }
      })
      .catch(() => {
        this.enableParallax = false;
      });
  }

  async waitForGSAP() {
    try {
      if (window.gsapLoader) {
        await window.gsapLoader.load(['ScrollTrigger']);
        return true;
      }

      const maxAttempts = 50;
      let attempts = 0;

      while (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (attempts++ > maxAttempts) {
          this.enableParallax = false;
          return false;
        }
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      gsap.registerPlugin(ScrollTrigger);
      return true;
    } catch (error) {
      console.error('Failed to load GSAP for beat-the-heat-hero:', error);
      this.enableParallax = false;
      return false;
    }
  }

  init() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    if (this.enableLoadAnimation) {
      setTimeout(() => {
        this.setFinalPositions();
        this.section.classList.add('animate-none');
        this.enableParallax && this.setupScrollAnimation();
      }, 800);
    } else {
      this.setFinalPositions();
      this.enableParallax && this.setupScrollAnimation();
    }
  }

  setFinalPositions() {
    this.productImages.forEach((hat) => {
      const position = this.getHatPosition(hat);
      const config = this.hatConfig[position];

      if (config) {
        gsap.set(hat, {
          clearProps: 'transform',
          transform: config.from
        });
      }
    });
  }

  setupScrollAnimation() {
    this.scrollTriggers.forEach((trigger) => trigger.kill());
    this.scrollTriggers = [];

    const triggerElement = this.section.querySelector('.ne-container') || this.section;

    this.productImages.forEach((hat) => {
      const position = this.getHatPosition(hat);
      const config = this.hatConfig[position];

      if (!config) {
        return;
      }

      gsap.set(hat, {
        clearProps: 'transform',
        transform: config.from
      });

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        return;
      }

      const trigger = gsap.fromTo(
        hat,
        { transform: config.from },
        {
          transform: config.to,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            start: 'clamp(top center)',
            end: 'clamp(bottom 20%)',
            scrub: true,
            invalidateOnRefresh: true,
            refreshPriority: -90,
            onRefresh: () => gsap.set(hat, { transform: config.from })
          }
        }
      );

      this.scrollTriggers.push(trigger.scrollTrigger);
    });

    ScrollTrigger.refresh();
  }

  getHatPosition(hat) {
    return (
      Object.keys(this.hatConfig).find((position) =>
        hat.classList.contains(this.hatConfig[position].className)
      ) || null
    );
  }

  destroy() {
    this.scrollTriggers.forEach((trigger) => trigger.kill());
    this.scrollTriggers = [];
    this.isInitialized = false;
  }
}

const initializeHeroSections = (() => {
  let timeoutId;
  const instances = new WeakMap();

  return (container = document) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const sections = container.querySelectorAll('.beat-the-heat-hero');

      sections.forEach((section) => {
        if (!instances.has(section)) {
          const instance = new BeatTheHeatHero(section);
          instances.set(section, instance);
        }
      });
    }, 50);
  };
})();

document.addEventListener('DOMContentLoaded', () => initializeHeroSections());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-slider-assets"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const eventModule = {
    init: function () {
      const events = {
        SCRIPTS_LOADED: new Event('SCRIPTS_LOADED'),
        SCRIPT_FAILED: new Event('SCRIPT_FAILED'),
        PRE_ENTER_VIEWPORT: new Event('PRE_ENTER_VIEWPORT'),
        ENTER_VIEWPORT: new Event('ENTER_VIEWPORT'),
        LEAVE_VIEWPORT: new Event('LEAVE_VIEWPORT'),
        FULLY_IN_VIEWPORT: new Event('FULLY_IN_VIEWPORT'),
        IMAGE_READY: new Event('IMAGE_READY'),
        IMAGE_ERROR: new Event('IMAGE_ERROR')
      };

      Object.assign(window, events);
    }
  };

  const viewportModule = {
    init: function () {
      const handleViewport = function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting
            ? entry.target.classList.contains('out-isvisible') ||
              (entry.target.classList.add('out-isvisible'),
              entry.target.dispatchEvent(ENTER_VIEWPORT),
              entry.target.classList.contains('out-wasviewed') ||
                entry.target.classList.add('out-wasviewed'))
            : entry.target.classList.contains('out-isvisible') &&
              (entry.target.classList.remove('out-isvisible'),
              entry.target.dispatchEvent(LEAVE_VIEWPORT));
        });
      };

      const handlePreEnterViewport = function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting && entry.target.dispatchEvent(PRE_ENTER_VIEWPORT);
        });
      };

      const observeViewport = function (target, preloadDistance) {
        new IntersectionObserver(handleViewport).observe(target);

        if (preloadDistance) {
          let distance = preloadDistance;
          if (preloadDistance === 'true' || preloadDistance === 'desktop') {
            distance = '25%';
          } else if (preloadDistance && preloadDistance.indexOf('{') > -1) {
            const distanceData = JSON.parse(preloadDistance.replace(/'/g, '"'));
            distance = distanceData.desktop;
          }

          new IntersectionObserver(handlePreEnterViewport, {
            rootMargin: distance
          }).observe(target);
        }
      };

      const init = function () {
        const blocks = document.querySelectorAll('.out-block');

        blocks.forEach(function (block) {
          observeViewport(block, block.dataset.preload);
        });
      };

      if (document.readyState === 'complete') {
        init();
      }

      if (window.addEventListener) {
        addEventListener('DOMContentLoaded', init, false);
        addEventListener('load', init, false);
      } else if (window.attachEvent) {
        attachEvent('onDOMContentLoaded', init);
        attachEvent('onload', init);
      }
    }
  };

  const lazyLoaderModule = {
    init: function () {
      const loadImage = function (container, image) {
        function handleLoad() {
          container.classList.add('out-imgLoaded');
          container.dispatchEvent(IMAGE_READY);
          image.classList.add('out-imgLoaded');
          container.classList.remove('out-ll_ready');
        }

        image.addEventListener('load', handleLoad, false);

        if (image.src && image.complete) {
          handleLoad();
        }

        image.addEventListener(
          'error',
          function () {
            container.classList.add('out-imgError');
            container.dispatchEvent(IMAGE_ERROR);
          },
          false
        );
      };

      const processImages = function (block) {
        block.querySelectorAll('.out-imagery').forEach(function (imagery) {
          const img = imagery.querySelector('img');

          if (img.dataset.src && img.dataset.src !== '') {
            img.setAttribute('src', img.dataset.src);
            loadImage(imagery, img);
          }
        });
      };

      const processLazyLoadBlocks = function () {
        document.querySelectorAll('.out-block.out-lazyLoad').forEach(function (block) {
          if (!block.classList.contains('out-imgLoaded')) {
            if (block.classList.contains('out-isvisible')) {
              processImages(block);
            } else {
              if (block.dataset.preload) {
                block.addEventListener(
                  'PRE_ENTER_VIEWPORT',
                  function () {
                    processImages(this);
                  },
                  { once: true }
                );
              }

              if (!block.classList.contains('out-ll_manual')) {
                block.addEventListener(
                  'ENTER_VIEWPORT',
                  function () {
                    processImages(this);
                  },
                  { once: true }
                );
              }

              block.addEventListener(
                'LOAD_IMAGE',
                function () {
                  processImages(this);
                },
                { once: true }
              );
            }

            block.classList.add('out-ll_ready');
          }
        });
      };

      processLazyLoadBlocks();
    }
  };

  eventModule.init();
  window._out = window._out || {};
  viewportModule.init();
  lazyLoaderModule.init();
})();

(function () {
  let isDesktop = window.matchMedia('(min-width: 768px)');
  let refreshed = false;

  async function initializeWhenReady() {
    try {
      if (window.gsapLoader) {
        await window.gsapLoader.load();
      }
    } catch (error) {
      console.error('Failed to load GSAP for collection slider:', error);
      return;
    }

    initializeSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWhenReady, { once: true });
  } else {
    initializeWhenReady();
  }

  function initializeSlider() {
    const cardStacks = document.querySelectorAll('.out-sliderstacked');

    if (cardStacks.length !== 0) {
      cardStacks.forEach(function ($element) {
        if (!$element.classList.contains('out-slider-loaded')) {
          $element.classList.add('out-slider-loaded');
          setupCardStack($element);
        }
      });
    }
  }

  function setupCardStack(el) {
    const cardWrap = el;
    const cardStack = cardWrap.querySelector('.out-cards');
    const duration = 3;
    const pausebutton = document.createElement('button');
    const arrowPrev = document.createElement('button');
    const arrowNext = document.createElement('button');
    const counter = document.createElement('div');
    const timer = document.createElement('div');
    const timerBar = document.createElement('span');

    pausebutton.classList.add('out-looppause', 'out-button');
    pausebutton.setAttribute('aria-label', 'Pause');
    arrowPrev.classList.add('out-arrow-left', 'out-arrow', 'out-button');
    arrowPrev.setAttribute('aria-label', 'Previous');
    arrowNext.classList.add('out-arrow-right', 'out-arrow', 'out-button');
    arrowNext.setAttribute('aria-label', 'Next');
    counter.classList.add('out-counter');
    timer.classList.add('out-timer');
    timerBar.classList.add('out-timer-bar');
    timer.appendChild(timerBar);

    cardWrap.appendChild(timer);
    cardStack.appendChild(pausebutton);
    cardStack.appendChild(arrowPrev);
    cardStack.appendChild(arrowNext);
    cardStack.appendChild(counter);

    let cards = cardStack.querySelectorAll('.out-slide');
    let activeIdx = 0;
    let tl = gsap.timeline({ duration: 1.02, ease: 'power2.inOut' });
    let clicked = false;
    let moving = false;
    let cTop;
    let cMid;
    let cBot;
    let cNxt;
    let cCopy;
    let cTopCopy;
    let left1;
    let left2;
    let left3;
    let left4;
    let left5;
    let top1;
    let top2;
    let top3;
    let top4;
    let top5;

    function isHidden(elem) {
      const styles = window.getComputedStyle(elem);
      return styles.display === 'none';
    }

    cards.forEach(function ($element) {
      if (isHidden($element)) {
        $element.remove();
      }
    });

    cards = cardStack.querySelectorAll('.out-slide');

    function setSizes() {
      left1 = percentage(7, cMid.offsetWidth * 1.12);
      left2 = percentage(0, cMid.offsetWidth);
      left3 = percentage(5, cMid.offsetWidth * 0.9);
      left4 = percentage(10, cMid.offsetWidth * 0.75);
      left5 = percentage(25, cMid.offsetWidth * 0.6);
      top1 = percentage(7, cMid.offsetHeight * 1.12);
      top2 = percentage(0, cMid.offsetHeight);
      top3 = percentage(5, cMid.offsetHeight * 0.9);
      top4 = percentage(10, cMid.offsetHeight * 0.75);
      top5 = percentage(25, cMid.offsetHeight * 0.6);
    }

    window.addEventListener('resize', function () {
      setSizes();
    });

    cards.forEach(function ($element, index) {
      $element.setAttribute('data-num', index + 1);
    });

    cards[0].classList.add('out-active');

    function checkDuration(idx) {
      activeIdx = idx;
      if (cards[idx].dataset.duration) {
        const tScale = duration / cards[idx].dataset.duration;
        autoPlay.timeScale(tScale);
      } else {
        autoPlay.timeScale(1);
      }
    }

    function setCards() {
      cTop = cards[0];
      cMid = cards[1];
      cBot = cards[2];
      cNxt = cards[3];
      cCopy = cardStack.querySelectorAll('.out-caption');
      cTopCopy = cTop.querySelector('.out-caption');

      cTop.style.zIndex = '3';
      cMid.style.zIndex = '2';
      cBot.style.zIndex = '1';
      cNxt.style.zIndex = '0';
      cTop.style.opacity = 1;
      cMid.style.opacity = 1;
      cMid.style.left = left3 + 'px';
      cMid.style.top = top3 + 'px';
      cMid.style.transform = 'scale(1)';
      cBot.style.opacity = 1;
      cBot.style.left = left4 + 'px';
      cBot.style.top = top4 + 'px';
      cBot.style.transform = 'scale(1)';
      cTopCopy.style.opacity = 1;
    }

    setCards();
    setSizes();

    counter.innerHTML = '<span>' + cTop.dataset.num + '</span><span>' + cards.length + '</span>';

    cMid.style.left = left3 + 'px';
    cBot.style.left = left4 + 'px';
    cMid.style.top = top3 + 'px';
    cBot.style.top = top4 + 'px';

    function handleVideos() {
      moving = false;
      cards.forEach(function ($element) {
        if ($element.classList.contains('out-active') && !cardWrap.classList.contains('user_paused')) {
          if ($element.querySelector('.out-hasvideo') != null) {
            $element.getElementsByTagName('video')[0].play();
          }
        } else if ($element.querySelector('.out-hasvideo') != null) {
          $element.getElementsByTagName('video')[0].pause();
        }
      });
    }

    function percentage(p, t) {
      return parseInt((t * p) / 100, 10);
    }

    function pauseVids() {
      cards.forEach(function ($element) {
        if ($element.querySelector('.out-hasvideo') != null) {
          $element.getElementsByTagName('video')[0].pause();
        }
      });
    }

    function updateStack() {
      moving = true;
      checkDuration(1);
      setCards();

      tl = gsap.timeline({
        duration: 1.02,
        onComplete: handleVideos,
        onStart: pauseVids
      });

      tl.to(cTopCopy, 0.3, { opacity: 0 }, 0);
      tl.fromTo(cTop, 0.7, { scale: 1, opacity: 1 }, { opacity: 0 }, 0);
      tl.fromTo(
        cTop,
        1.02,
        { scale: 1, left: left2 + 'px', top: top2 + 'px' },
        { scale: 1, left: '-' + left1 + 'px', top: '-' + top1 + 'px' },
        0
      );
      tl.fromTo(
        cMid,
        1.02,
        { scale: 1, opacity: 1, left: left3 + 'px', top: top3 + 'px' },
        { scale: 1, opacity: 1, left: left2 + 'px', top: top2 + 'px' },
        0
      );
      tl.fromTo(
        cBot,
        1.02,
        { scale: 1, opacity: 1, left: left4 + 'px', top: top4 + 'px' },
        { scale: 1, opacity: 1, left: left3 + 'px', top: top3 + 'px' },
        0
      );
      tl.fromTo(
        cNxt,
        1.02,
        { scale: 1, opacity: 0, left: left5 + 'px', top: top5 + 'px' },
        { scale: 1, opacity: 1, left: left4 + 'px', top: top4 + 'px' },
        0
      );
      tl.fromTo(cCopy, 0.5, { opacity: 0, x: '20px' }, { opacity: 1, x: 0 }, 0.4);
      tl.fromTo(cTopCopy, 0.5, { opacity: 0 }, { opacity: 0, x: 0 }, 0.4);
      counter.innerHTML = '<span>' + cMid.dataset.num + '</span><span>' + cards.length + '</span>';
      cards.forEach(function ($element) {
        $element.classList.remove('out-active');
      });
      cMid.classList.add('out-active');
    }

    let autoPlay = null;

    function letsGo() {
      autoPlay = gsap.timeline({
        repeat: -1,
        duration: duration,
        onRepeat: loopThis,
        onStart: function () {
          checkDuration(0);
        }
      });
      autoPlay.fromTo(timerBar, duration, { '--p': '0' }, { '--p': '100%' }, 1.02);
    }

    if (autoPlay == null) {
      letsGo();
    } else if (!cardWrap.classList.contains('user_paused')) {
      autoPlay.play();
    }

    if (cardWrap.classList.contains('out-isvisible') && autoPlay == null) {
      letsGo();
    }

    cardWrap.addEventListener('LEAVE_VIEWPORT', function () {
      if (autoPlay != null) {
        autoPlay.pause();
      }
    });

    function loopThis() {
      cards = cardStack.querySelectorAll('.out-slide');
      const lastCard = cards[0];
      cardStack.appendChild(lastCard);
      updateStack();
      clicked = false;
    }

    function loopBack() {
      moving = true;
      cards = cardStack.querySelectorAll('.out-slide');
      const lastIdx = cards.length - 1;
      const lastCard = cards[lastIdx];
      cardStack.insertBefore(lastCard, cardStack.firstChild);
      checkDuration(0);
      cards = cardStack.querySelectorAll('.out-slide');
      setCards();
      cTopCopy.style.opacity = 0;
      tl = gsap.timeline({ onComplete: handleVideos, onStart: pauseVids });
      tl.fromTo(cCopy, 0.3, { opacity: 1 }, { opacity: 0 }, 0);
      tl.fromTo(cTop, 0.52, { opacity: 0 }, { opacity: 1 }, 0);
      tl.fromTo(
        cTop,
        1.02,
        { scale: 1, left: '-' + left1 + 'px', top: '-' + top1 + 'px' },
        { scale: 1, left: left2 + 'px', top: top2 + 'px' },
        0
      );
      tl.fromTo(
        cMid,
        1.02,
        { scale: 1, opacity: 1, left: left2 + 'px', top: top2 + 'px' },
        { scale: 1, opacity: 1, left: left3 + 'px', top: top3 + 'px' },
        0
      );
      tl.fromTo(
        cBot,
        1.02,
        { scale: 1, opacity: 1, left: left3 + 'px', top: top3 + 'px' },
        { scale: 1, opacity: 1, left: left4 + 'px', top: top4 + 'px' },
        0
      );
      tl.fromTo(
        cNxt,
        1.02,
        { scale: 1, opacity: 1, left: left4 + 'px', top: top4 + 'px' },
        { scale: 1, opacity: 0, left: left5 + 'px', top: top5 + 'px' },
        0
      );
      tl.fromTo(cTopCopy, 0.5, { opacity: 0, x: '20px' }, { opacity: 1, x: 0 }, 0.4);
      counter.innerHTML = '<span>' + cTop.dataset.num + '</span><span>' + cards.length + '</span>';
      cards.forEach(function ($element) {
        $element.classList.remove('out-active');
      });
      cTop.classList.add('out-active');
    }

    pausebutton.addEventListener('click', function () {
      if (cardWrap.classList.contains('user_paused')) {
        if (clicked) {
          autoPlay.seek(0);
          clicked = false;
        }
        autoPlay.play();
        cardWrap.classList.remove('user_paused');
      } else {
        autoPlay.pause();
        cardWrap.classList.add('user_paused');
      }
    });

    arrowNext.addEventListener('click', function () {
      if (!moving) {
        autoPlay.progress(1, false);
        if (cardWrap.classList.contains('user_paused')) {
          loopThis();
        }
        clicked = true;
      }
    });

    arrowPrev.addEventListener('click', function () {
      if (!moving) {
        autoPlay.seek(0);
        loopBack();
      }
    });
  }

  return;
})();
  } catch(e) { console.error(e); }
})();

})();
